import React from 'react';
import { Button } from 'antd';
import { ArrowRightOutlined, CheckOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { ACCESS_SECTION, PAYMENT_PLAN_HIGHLIGHTS } from '../content/landingContent';
import LandingSectionHead from './LandingSectionHead';

const LandingAccessCta: React.FC = () => (
  <section id="pricing" className="cp-landing-section cp-landing-section--access">
    <div className="cp-landing-container">
      <div className="cp-landing-access-cta">
        <LandingSectionHead
          eyebrow={ACCESS_SECTION.eyebrow}
          title={ACCESS_SECTION.title}
          lead={ACCESS_SECTION.lead}
          centered
        />
        <div className="cp-landing-access-cta__panel">
          <p className="cp-landing-access-cta__panel-title">Flexible payment</p>
          <ul className="cp-landing-access-cta__highlights" aria-label="Payment options">
            {PAYMENT_PLAN_HIGHLIGHTS.map((item) => (
              <li key={item}>
                <CheckOutlined aria-hidden />
                {item}
              </li>
            ))}
          </ul>
        </div>
        <div className="cp-landing-access-cta__actions">
          <Link to="/signup">
            <Button type="primary" size="large" className="cp-landing-btn-primary" icon={<ArrowRightOutlined />}>
              {ACCESS_SECTION.primaryLabel}
            </Button>
          </Link>
          <Link to="/login">
            <Button size="large" className="cp-landing-btn-secondary">
              Sign in
            </Button>
          </Link>
        </div>
        <p className="cp-landing-access-cta__note">
          Already approved? Use sign in with your work email. New organizations are reviewed before access is enabled.
        </p>
      </div>
    </div>
  </section>
);

export default LandingAccessCta;
